import { IUnreadMessages } from "@interfaces/chat/chatI";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export const messageSocketUnreadMessageSlice = createSlice({
    name:'messageSocketUnreadMessage',
    initialState:{
        unreadMessages: [],
    } as {unreadMessages: IUnreadMessages[]},
    reducers:{
        setUnreadMessages: (state, action: PayloadAction<IUnreadMessages>) => {
            const checkExistant = state.unreadMessages.some(eachUnread => eachUnread.id === action.payload.id)
            if(!checkExistant) 
                state.unreadMessages.push(action.payload)
        },
        removeUnreadMessages: (state, action: PayloadAction<IUnreadMessages>) => {
            const filteredData = state.unreadMessages.filter(unreadMessage => unreadMessage.id !== action.payload.id);
            state.unreadMessages = filteredData;
        },
        cleanUnreadMessages: (state) => {
            state.unreadMessages = [];
        }
    }
});

export const {setUnreadMessages, removeUnreadMessages, cleanUnreadMessages } = messageSocketUnreadMessageSlice.actions;
export default messageSocketUnreadMessageSlice.reducer;